import { useQuery } from '@tanstack/vue-query'
import { getApi } from "./api";
export default (dialogId: number) => useQuery({
    queryKey: ['dialog-messages', dialogId],
    queryFn: () => {
        const { api, baseURL } = getApi();
        return api.get(`api/v2/dialogs/${dialogId}/messages`, { baseURL, useOriginalToken: true }).then( res => res.data.data );
    },
})
